import { render, staticRenderFns } from "./setAdminModel.vue?vue&type=template&id=a044737c&scoped=true&"
import script from "./setAdminModel.vue?vue&type=script&lang=js&"
export * from "./setAdminModel.vue?vue&type=script&lang=js&"
import style0 from "./setAdminModel.vue?vue&type=style&index=0&id=a044737c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a044737c",
  null
  
)

export default component.exports